export enum LogTransports {
  CONSOLE = "console",
  STORAGE = "storage",
}
